import React from 'react';

const FlipOverrideSection = ({ 
  job,
  formData,
  setFormData,
  handleChange,
  user
}) => {
  // Only show for admin users
  if (user?.role !== 'ADMIN') {
    return null;
  }

  return (
    <div className="mt-4 border-t border-gray-200 pt-4">
      <h4 className="text-sm font-medium text-gray-700 mb-3">Flip Override (Admin Only)</h4>
      
      <div className="space-y-3">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="flipOverridden"
            name="flipOverridden"
            checked={formData.flipOverridden}
            onChange={handleChange}
            className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-gray-300 rounded"
          />
          <label htmlFor="flipOverridden" className="ml-2 block text-sm text-gray-700">
            Override automatic flip detection
          </label>
        </div>
        
        {formData.flipOverridden && (
          <div className="ml-6 space-y-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Manual flip setting:
            </label>
            <div className="space-y-2">
              <div className="flex items-center">
                <input
                  type="radio"
                  id="flipYes"
                  name="flipOverrideValue"
                  checked={formData.flipOverrideValue === true}
                  onChange={() => setFormData(prev => ({
                    ...prev,
                    flipOverrideValue: true
                  }))}
                  className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300"
                />
                <label htmlFor="flipYes" className="ml-2 text-sm text-gray-700">
                  <span className="font-medium text-red-600">Yes</span> - Treat as flip (red FLIP banner, delete walkthrough)
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="radio"
                  id="flipNo"
                  name="flipOverrideValue"
                  checked={formData.flipOverrideValue === false}
                  onChange={() => setFormData(prev => ({
                    ...prev,
                    flipOverrideValue: false
                  }))}
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300"
                />
                <label htmlFor="flipNo" className="ml-2 text-sm text-gray-700">
                  <span className="font-medium text-green-600">No</span> - Treat as normal (allow walkthrough creation)
                </label>
              </div>
            </div>
          </div>
        )}
        
        {/* Status indicator */}
        <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
          <div><strong>Current flip status:</strong> {job.isFlip ? 'Flip' : 'Not a flip'}</div>
          {job.flipOverridden && (
            <div className="text-amber-600 mt-1">
              <strong>Override active:</strong> Manually set to {job.flipOverrideValue ? 'Flip' : 'Not a flip'}
            </div>
          )}
          {!job.flipOverridden && (
            <div className="text-blue-600 mt-1">
              <strong>Automatic detection:</strong> Based on reservation timing
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlipOverrideSection;